import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, ElementType, forwardRef } from "react"
import { TYPE_CLASS, TypeVariant } from "./typeVariant"

type TypographyProps = ComponentPropsWithoutRef<"div"> & {
  as?: ElementType
  variant?: TypeVariant
}

export const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ as: Comp = "div", variant, className, ...props }: any, ref) => (
    <Comp
      ref={ref}
      className={cn(
        variant && TYPE_CLASS[variant],
        className,
        "[&_ul]:type-body-m [&_ul]:pl-5 [&_ul_li]:list-disc [&_ol]:type-body-m [&_ol]:pl-5 [&_ol_li]:list-decimal",
      )}
      {...props}
    />
  ),
)
Typography.displayName = "Typography"
